import { render, staticRenderFns } from "./_AudioAssuntoCadastro.vue?vue&type=template&id=239c3e1f&scoped=true"
import script from "./_AudioAssuntoCadastro.vue?vue&type=script&lang=ts"
export * from "./_AudioAssuntoCadastro.vue?vue&type=script&lang=ts"
import style0 from "./_AudioAssuntoCadastro.vue?vue&type=style&index=0&id=239c3e1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239c3e1f",
  null
  
)

export default component.exports